// Logo de marca por cliente.
//
// - El logo del proyecto viene SIEMPRE de la config del tenant
//   (branding.logoUrl de /api/g/v2/clients/me/config). Si el proyecto no define
//   logo, en los navbars NO se pinta nada (sin default, sin logo ajeno).
// - Para que el LOGIN se sienta personalizado ANTES de autenticar (cuando aún
//   no hay config), se recuerda el último logo del cliente en una cookie por
//   dispositivo. Si no hay cookie, el login muestra el logo de Instrutrónica.

export const INSTRUTRONICA_LOGO = "/assets/clients/default/logo.png";
const COOKIE = "clientLogo";
const MAX_AGE = 60 * 60 * 24 * 365; // 1 año

export function setLogoCookie(url) {
  if (!url) return clearLogoCookie();
  document.cookie = `${COOKIE}=${encodeURIComponent(url)}; path=/; max-age=${MAX_AGE}; SameSite=Lax`;
}

export function clearLogoCookie() {
  document.cookie = `${COOKIE}=; path=/; max-age=0; SameSite=Lax`;
}

export function getLogoCookie() {
  const m = document.cookie.match(new RegExp("(?:^|; )" + COOKIE + "=([^;]*)"));
  return m ? decodeURIComponent(m[1]) : null;
}

// Logo del LOGIN: el recordado del cliente (cookie) o, si no hay, Instrutrónica.
export function loginLogo() {
  return getLogoCookie() || INSTRUTRONICA_LOGO;
}
